export default {
  messageList: state => state.messageList,
}
